<template>
  <SelectSingleInput
    v-model="model"
    :items="items"
    item-text="defectGroupItemText"
    item-value="defectGroupCd"
    :label="labelComputed"
    :disabled="disabled"
    :loading="loading"
    :required="required"
  />
</template>

<script>
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'

export default {
  name: 'DefectGroupInput',

  mixins: [APIUtils, Message],

  components: {
    SelectSingleInput,
  },

  props: {
    value: {
      type: String,
      default: '',
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    validOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    label: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      items: [],
      loading: false,
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
    labelComputed: {
      get() {
        return this.label ? this.label : this.$t('ELE0008')
      },
    },
  },

  async mounted() {
    this.loading = true
    try {
      const params = {}
      if (this.validOnly) {
        params.validOnly = true
      }

      const elements = await API.get('/master/defectGroups', params)

      elements.forEach((item) => {
        item['defectGroupItemText'] = `${item['defectGroupCd']} : ${item['defectGroupName']}`
        this.items.push(item)
      })
    } catch (error) {
      this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0009') })))
    } finally {
      this.loading = false
    }
  },
}
</script>
